/* eslint-disable max-len */
export default {
    tooltip: 'Complete the form and download the ebook.',
    form: {
        title: 'Complete the form and download the ebook',
        placeholder: {
            name: 'Name',
            surname: 'Surname',
            email: 'Your corporate email',
            company: 'Company'
        },
        label: {
            checkbox: 'The data are administered by Sagiton Sp.z o.o., have been provided voluntarily and will be processed by the administrator in accordance with the provisions of the Act of 29 August 1997r. about the protection of personal data (Journal of Laws of 2002, No. 101, item 926, as amended) for marketing purposes, sale of products and services Sagiton Sp.z o.o. I have been informed of the right of access to the content of their data, their correcting and the right to lodge objections to their processing at any time.',
            checkbox2: 'I agree to receive from Sagiton Sp.z o.o. commercial information by email.',
            button: 'Download e-book for free',
            refresh: 'Refresh'
        }
    },
    footer: {
        title: 'Are you interested in a comprehensive solution<br/> for your data security?',
        button: 'Find out our offer'
    },
    download: {
        text: 'Thank you for completing the form. Link that allows you to download the ebook was send to your email address.'
    },
    list: [{
        id: 'gdpr_all_about',
        slug: 'gdpr-all-about',
        header: {
            title: 'Download free ebook',
            subtitle: 'Everything you should know about GDPR',
            cover: {
                image: 'gdpr-all-about-cover-en.jpg',
                alt: 'Download free ebook - Everything you should know about GDPR'
            }
        },
        content: {
            title: 'In our guidebook you will find the following information:',
            list: [
                'Does GDPR apply to you or your organization?',
                'What kind of data will be under protection and if processing of some data will be forbidden?',
                'What penalties can your organization face in case of wrong data processing?',
                'And the most importantly, how to prove you&apos;re protecting your data properly in case of control audit.'
            ]
        }
    }, {
        id: 'gdpr_for_marketing',
        slug: 'gdpr-for-marketing',
        header: {
            title: 'Download free guidebook',
            subtitle: 'Marketing compatible with GDPR',
            cover: {
                image: 'gdpr-for-marketing-cover-en.png',
                alt: 'Download free ebook - Marketing compatible with GDPR'
            }
        },
        content: {
            title: 'From our guidebook you will learn:',
            list: [
                'How to conduct the profiling process compatible with GDPR?',
                'What the consent to the processing of personal data should look like?',
                'How the marketing department can protect the information?',
                'And also you will find out about the five principles of cooperation between marketing and security'
            ]
        }
    }, {
        id: 'views_on_cybersecurity',
        slug: 'views-on-cybersecurity',
        header: {
            title: 'Expert guidebook',
            subtitle: 'Three views on cybersecurity',
            cover: {
                image: 'views-on-cybersecurity-cover-en.png',
                alt: 'Download free ebook - Three views on cybersecurity'
            }
        },
        content: {
            title: 'From our e-book you will learn:',
            list: [
                'what data in the company should be secured,',
                'how cybercriminals work and who can be targeted by them,',
                'find out if organizations are aware of their own weaknesses and the need to adapt to the provisions of the GDPR,',
                'what is a systemic approach to security.'
            ]
        }
    }]
};



// WEBPACK FOOTER //
// ./src/i18n/en/ebook.js